import { useShowContext } from 'framework/show';
import { useDateService } from 'framework/utils';
import { ProcessedLeaveYear } from '../../shared/types';

const LeaveTakenField = ({ showDaysOnDemand = false }: { showDaysOnDemand?: boolean }) => {
  const { data } = useShowContext<ProcessedLeaveYear>();
  const period = data?.getData();
  const { isCurrentTimeInPeriod } = useDateService();
  const isCurrentYearPeriod = isCurrentTimeInPeriod(period?.startDate, period?.endDate);

  if (!period) return <span>0d</span>;
  if (period.hideBalanceColumns) return null;

  const takenPaid = period.taken ?? 0;
  const takenOnDemand = Number(period.dayOnDemandsTotalBalance ?? 0) - Number(period.dayOnDemandsRemainedBalance ?? 0);

  if (showDaysOnDemand && period.hasDayOnDemandBalance && isCurrentYearPeriod) {
    return (
      <span>
        {takenPaid}d/{takenOnDemand}d on demand
      </span>
    );
  }

  return <span>{takenPaid}d</span>;
};

export default LeaveTakenField;
